import logger from '../utils/logger';
// src/lib/tagHelpers.js
// Centralized tag parsing utility that handles PostgreSQL array formats

export const parseTags = (tags) => {
  if (!tags) return [];
  
  // If it's already a proper JavaScript array, just ensure strings
  if (Array.isArray(tags)) {
    return tags.map(t => String(t).trim()).filter(Boolean);
  }
  
  // If it's a string, we need to parse it
  if (typeof tags === 'string') {
    const trimmed = tags.trim();
    
    // Handle JSON array format: ["tag1","tag2","tag3"]
    if (trimmed.startsWith('[') && trimmed.endsWith(']')) {
      try {
        const parsed = JSON.parse(trimmed);
        if (Array.isArray(parsed)) {
          return parsed.map(t => String(t).trim()).filter(Boolean);
        }
      } catch (e) {
        logger.warn('Failed to parse tags as JSON array:', trimmed, e);
      }
    }
    
    // Handle PostgreSQL array literal format: {tag1,tag2,tag3}
    if (trimmed.startsWith('{') && trimmed.endsWith('}')) {
      const innerContent = trimmed.slice(1, -1);
      if (!innerContent) return [];
      
      // Parse considering quoted values
      const parsedTags = [];
      let current = '';
      let inQuotes = false;
      
      for (let i = 0; i < innerContent.length; i++) {
        const char = innerContent[i];
        
        if (char === '"' && (i === 0 || innerContent[i-1] !== '\\')) {
          inQuotes = !inQuotes;
        } else if (char === ',' && !inQuotes) {
          if (current) {
            parsedTags.push(current.trim().replace(/^"|"$/g, ''));
          }
          current = '';
        } else {
          current += char;
        }
      }
      
      if (current) {
        parsedTags.push(current.trim().replace(/^"|"$/g, ''));
      }
      
      return parsedTags.filter(Boolean);
    }
    
    // If it's just a plain string, treat as single tag
    return [trimmed].filter(Boolean);
  }
  
  // If it's an object, try to extract values
  if (typeof tags === 'object' && tags !== null) {
    const values = Object.values(tags);
    if (values.length > 0) {
      return values.map(t => String(t).trim()).filter(Boolean);
    }
  }
  
  logger.warn('Unexpected tags format:', tags, typeof tags);
  return [];
};

// Safe string converter for other fields
export const asString = (v) => {
  if (v == null) return '';
  if (typeof v === 'string') return v;
  if (typeof v === 'number') return String(v);
  if (typeof v === 'boolean') return String(v);
  try {
    return JSON.stringify(v);
  } catch {
    return String(v);
  }
};